export default function LoadingIndicator() {
    return <div className="loading"> </div>
}